export const StatCardStatistics = ({ icon, title, value, subtitle }) => (
    <div className="stat-card">
      <div className="stat-card-header">
        <div className={`stat-icon ${icon.color}`}>
          {icon.Icon ? <icon.Icon size={20} strokeWidth={2} /> : <i className={icon.class}></i>}
        </div>
        <div className="stat-title">{title}</div>
      </div>
      <div className="stat-value">{value}</div>
      {subtitle && <div className="stat-change">{subtitle}</div>}
    </div>
  );
